function minuteSince(date) {
  var seconds = Math.floor((new Date() - date) / 1000);
  var interval = seconds / 31536000; // In seconds
  interval = seconds / 60;

  return (Math.round(interval));
}

function minuteUntil(date) {
  var seconds = Math.floor((date - new Date()) / 1000);
  var interval = seconds / 31536000; // In seconds
  interval = seconds / 60;

  return (Math.round(interval));
}

//Epoch time (milliseconds) To Date
function epochToDate(epoch) {
  let timeZoneOffset = (new Date()).getTimezoneOffset();

  //epoch = epoch + (new Date().getTimezoneOffset() * -1); //for timeZone
  epoch = epoch - timeZoneOffset;

  let date =  new Date(epoch);
  return(date);
}

// Supports 12 hour (hourFormat='12h') or 24 hour (hourFormat='24h') format (default).  
function formatDate(inputDate, hourFormat) {

  let tmpDate;

  if (!inputDate)
    return('');
  else {
    if (!(inputDate instanceof Date))
      tmpDate = new Date(inputDate);
  }

  //let day     = tmpDate.getDay();  // Not used.  For future enhancement
  let hours   = tmpDate.getHours();
  let minutes = tmpDate.getMinutes();
  let year    = tmpDate.getFullYear();
  let month   = tmpDate.getMonth() + 1;
  let date    = tmpDate.getDate();
  let formatted;

  let minuteStr =  minutes.toString().padStart(2, "0");

  if (hourFormat === '24h') {
    formatted  =  year + '-' + month.toString().padStart(2, "0") + '-' + date.toString().padStart(2, "0") + ', ' +
              hours.toString().padStart(2, "0") + ':' + minutes.toString().padStart(2, "0");
  } else {
    let time12  = hours < 1 ?
                    ('12:' + minuteStr + ' AM')
                  :
                    (hours < 12 ?
                      (hours.toString().padStart(2, "0") + ':' + minuteStr + ' AM')
                    :
                      (hours === 12 ?
                         ('12:' + minuteStr + ' PM')
                       :
                         ((hours-12).toString().padStart(2, "0") + ':' + minuteStr + ' PM')
                      )
                    );

    formatted  =  year + '-' + month.toString().padStart(2, "0") + '-' + date.toString().padStart(2, "0") + ', ' +
                  time12;
  }

  return(formatted);
}

function formatDateOnly(inputDate) {

  let tmpDate;

  if (!inputDate)
    return('');
  else {
    if (!(inputDate instanceof Date))
      tmpDate = new Date(inputDate);
  }

  let year    = tmpDate.getFullYear();
  let month   = tmpDate.getMonth() + 1;
  let date    = tmpDate.getDate();
  let formatted;

  formatted  =  year + '-' + month.toString().padStart(2, "0") + '-' + date.toString().padStart(2, "0");

  return(formatted);
}


module.exports = {
  minuteSince:    minuteSince,
  minuteUntil:    minuteUntil,
  epochToDate:    epochToDate,
  formatDate:     formatDate,
  formatDateOnly: formatDateOnly
};
